<script>
import DynamicDisease from './DynamicDisease'

export default {
  name: 'Disease',

  components: {
    DynamicDisease
  },
  props: {
    'answers-json': String,
    'answer-accuracies-json': String
  },

  data() {
    return {
      answer: null,
      currentPercent: this.getNewPercent(),

      showResult: false,
      correct: false,
    }
  },
  computed: {
    answers(){
      return JSON.parse(this.answersJson)
    },
    accuracies(){
      return JSON.parse(this.answerAccuraciesJson)
    },
    showSuccess(){
      return this.correct && this.showResult
    },
    showWrong(){
      return !this.correct && this.showResult
    }
  },
  methods: {
    nextQuestion(){
      this.showResult = false
      this.answer = null
      this.currentPercent = this.getNewPercent()
    },
    submit(){
      let accuracy = 4
      for(let i in this.accuracies){
        if(i < this.currentPercent)
          accuracy = parseInt(this.accuracies[i])
      }
      let maxThreshold = this.currentPercent + accuracy
      let minThreshold = this.currentPercent - accuracy

      if(this.answer > minThreshold && this.answer < maxThreshold)
        this.correct = true
      else
        this.correct = false

      this.showResult = true

    },
    getNewPercent(){
      return Math.round(Math.random() * 80) // Change to Disease Max Percent
    }
  }
}
</script>

<template>
<div>
  <dynamic-disease v-bind="$attrs" :initial-percent="currentPercent" is-quiz/>


  <div class="row">
    <div class="col-6">
      <template v-for="(key, value) in answers">
        <div class="form-check">
          <input class="form-check-input" type="radio" name="answer" :value="value" v-model="answer">
          <label class="form-check-label" >{{ key }}</label>
        </div>
      </template>
    </div>
    <div class="col-6">
      <button class="btn btn-success btn-lg" type="button" @click="submit()">Submit</button>
      <button class="btn btn-lg btn-success" type="button" @click="nextQuestion()">Next Question</button>
      <div>
        <div class="card text-white bg-success" v-if="showSuccess">
          <div class="card-header">Nice Work!</div>
          <div class="card-body">
            <h5 class="card-title">{{currentPercent}}%</h5>
          </div>
        </div>
        <div class="card text-white bg-danger" v-if="showWrong">
          <div class="card-header">Opps...close</div>
          <div class="card-body">
            <h5 class="card-title">{{currentPercent}}%</h5>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
</template>



// WEBPACK FOOTER //
// resources/assets/js/components/Quiz.vue